import { render, staticRenderFns } from "./GeoSingle.vue?vue&type=template&id=74d8f994&scoped=true&"
import script from "./GeoSingle.vue?vue&type=script&lang=js&"
export * from "./GeoSingle.vue?vue&type=script&lang=js&"
import style0 from "./GeoSingle.vue?vue&type=style&index=0&id=74d8f994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d8f994",
  null
  
)

export default component.exports